var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTouchApp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "touch_app-24px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_33",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 33"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_700",
    "data-name": "\\u9577\\u65B9\\u5F62 700",
    width: 24,
    height: 24,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_36",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 36"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_35",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_34",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_39",
    "data-name": "\\u30D1\\u30B9 39",
    d: "M9,11.24V7.5a2.5,2.5,0,0,1,5,0v3.74a4.5,4.5,0,1,0-5,0Zm9.84,4.63L14.3,13.61a1.408,1.408,0,0,0-.54-.11H13v-6a1.5,1.5,0,0,0-3,0V18.24c-3.6-.76-3.54-.75-3.67-.75a1.119,1.119,0,0,0-.79.33l-.79.8,4.94,4.94a1.505,1.505,0,0,0,1.06.44h6.79a1.457,1.457,0,0,0,1.44-1.28l.75-5.27a1.437,1.437,0,0,0-.89-1.58Z",
    fill: "#fb2877"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTouchApp);
export default __webpack_public_path__ + "static/media/touch_app.b9d863b2d2441567cac8ce978dc43989.svg";
export { ForwardRef as ReactComponent };